var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contract)?_c('button',{staticClass:"md__btn-link m-0 p-0",on:{"click":function($event){$event.stopPropagation();return _vm.onDownloadContract()}}},[_c('WrapperTooltipComponent',{attrs:{"content":"Descargar"}},[_c('i',{staticClass:"h5 el-icon-download font-bold"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }